import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import 'dayjs/locale/en-gb'
import localizedFormat from 'dayjs/plugin/localizedFormat'

export const get = store => store.config.lang.get()

export const set = (store, value) => {
  const locale = value.replace('_', '-')
  store.config.lang.set(locale)
  // custom dayjs globally
  const lang = locale.substring(0, 2)
  dayjs.locale(lang === 'fr' ? 'fr' : 'en-gb')
  dayjs.extend(localizedFormat)
}

export const formatNumber = (store, number) =>
  (new Intl.NumberFormat(get(store)).format(number))

export const formatDate = (store, date) =>
  (new Intl.DateTimeFormat(get(store)).format(date))

const dateTimeOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: false,
}

export const formatDateTime = (store, date) =>
  (new Intl.DateTimeFormat(get(store), dateTimeOptions).format(date))

export default {
  get,
  set,
  formatNumber,
  formatDate,
  formatDateTime,
}
